import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeviceGroup_Interface, Empty_DeviceGroup_Interface } from 'src/app/Interface/DeviceGroup_Interface';

import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { PM_Program_Interface } from 'src/app/Interface/PM_Program_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceGroupService } from 'src/app/Service/DeviceGroup/DeviceGroup.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PM_ProgramService } from 'src/app/Service/PM/PM_Program.service';

@Component({
  selector: 'app-DeviceGroup',
  templateUrl: './DeviceGroup.component.html',
  styleUrls: ['./DeviceGroup.component.scss']
})
export class DeviceGroupComponent implements OnInit {

  Token:String=""
  Filter_title:String=""
  page:number=0
  Procssing:boolean=false
  DataList_DeviceGroup:Array<General_Interface>=[]

  Data_Seleted_Delete:General_Interface=Empty_General_Interface()
  Data_Seleted_ShowList:General_Interface=Empty_General_Interface()

  constructor(
    private DeviceGroup_Service:DeviceGroupService,
    private Alertify_Service:AlertifyService,
    private Nav_Service: NavService,
    private PM_Program_Service: PM_ProgramService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,45).subscribe(
      data=>{
        this.ReadData_DeviceGroup()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }



  ReadData_DeviceGroup(){
    this.Procssing=true
    this.DeviceGroup_Service.GetRecord1(this.Token,this.Data_Seleted_ShowList.id).subscribe(
      data=>{
        this.DataList_DeviceGroup=data
        this.Read_PM_Program()

        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Show_SubGroup(item)
  {
    this.Data_Seleted_ShowList=item
    this.ReadData_DeviceGroup()
  }

  Back_Group(){
    this.Data_Seleted_ShowList=Empty_General_Interface()
    this.ReadData_DeviceGroup()
  }

 //#region Add


  txtGroupTitle:String=''
  txtProgram_Id:String='0'
  Proccesing_Add:boolean=false
  modalRef_Add: any;

  openModal_Add(template: TemplateRef<any>) {
    this.txtGroupTitle=''
    this.txtProgram_Id='0'
    this.modalRef_Add = this.modalService.show(template);
  }

  Add(){
    if(!this.txtGroupTitle)
    {
      this.Alertify_Service.ErrorMessage("Please enter a title")
    }
    else{
      this.Proccesing_Add=true
      var temp:DeviceGroup_Interface=Empty_DeviceGroup_Interface();
      temp.id=0
      temp.title=this.txtGroupTitle,
      temp.parent = this.Data_Seleted_Delete.id
      temp.pm_program_id=Number(this.txtProgram_Id)

      this.DeviceGroup_Service.EditAddDeviceGroup(temp,this.Token).subscribe(
        data=>{
          this.Proccesing_Add=false
          this.txtGroupTitle=''
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
          this.ReadData_DeviceGroup()
        }
      )
    }

  }

 //#endregion


 //#region Edit

  Proccesing_Edit:boolean=false
  modalRef_Edi: any;

  openModal_Edi(template: TemplateRef<any>,item) {
    this.Data_Seleted_Delete = item
    this.txtProgram_Id=item.reserve_id
    this.txtGroupTitle=this.Data_Seleted_Delete.title
    this.modalRef_Edi = this.modalService.show(template);
  }

  Edit(){
    if(!this.txtGroupTitle)
    {
      this.Alertify_Service.ErrorMessage("Please enter a title")
    }
    else{
      this.Proccesing_Edit=true
      var temp:DeviceGroup_Interface=Empty_DeviceGroup_Interface();
      temp.id=this.Data_Seleted_Delete.id
      temp.title=this.txtGroupTitle
      temp.pm_program_id=Number(this.txtProgram_Id)

      this.DeviceGroup_Service.EditAddDeviceGroup(temp,this.Token).subscribe(
        data=>{
          this.Proccesing_Edit=false
          //this.txtGroupTitle=''
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
          this.ReadData_DeviceGroup()
        }
      )
    }

  }

  //#endregion


  //#region Delete


  modalRef_Delete: any;

  openModal_Delete(template: TemplateRef<any>,item) {
    this.Data_Seleted_Delete=item
    this.modalRef_Delete = this.modalService.show(template);
  }

  Delete(){

    this.modalRef_Delete.hide()
    this.DeviceGroup_Service.DeleteDeviceGroup(this.Data_Seleted_Delete.id,this.Token).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("Deleted successfully")
        this.ReadData_DeviceGroup()
      },error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

  Uncountable(item:General_Interface){

    this.DeviceGroup_Service.UncountableDeviceGroup(item.id,this.Token).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("Registered successfully")
        this.ReadData_DeviceGroup()
      },error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

  //#endregion

  //#region Tree

  DataList_DeviceGroup_Parent:Array<DeviceGroup_Interface>=[]
  DataList_DeviceGroup_Child:Array<DeviceGroup_Interface>=[]

  ReadData_DeviceGroup_Tree(){
    this.Procssing=true
    this.DataList_DeviceGroup_Parent=[]
    this.DataList_DeviceGroup_Child=[]
    this.DeviceGroup_Service.GetTree(this.Token).subscribe(
      data=>{
        this.DataList_DeviceGroup_Parent=data['parent']
        this.DataList_DeviceGroup_Child=data['child']

        for(let item of this.DataList_DeviceGroup_Parent)
        {
          item.child=[]
          for(let itemdetail of this.DataList_DeviceGroup_Child)
          {
            if(itemdetail.parent==item.id)
            {
              item.child.push(itemdetail)
            }
          }
        }

        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Data_List_Menu_Change(id){
    this.DataList_DeviceGroup_Parent[id].del=!this.DataList_DeviceGroup_Parent[id].del
  }

  //#endregion

  //#region PM Program

  DataList_PM_Program: Array<PM_Program_Interface> = []
  Read_PM_Program() {
    this.PM_Program_Service.GetActive(this.Token).subscribe(
      data => {
        this.DataList_PM_Program = data

      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  //#endregion


  Switcher_View:string='List'
  set_Switcher_View(item:string)
  {
    if(item=='Tree')
    {
      this.ReadData_DeviceGroup_Tree()
    }
    this.Switcher_View=item
  }

}
